import Flussi from "../";

const routes = [
    { name: "FlussiListPage", path: "/flussi", component: Flussi.FlussiListPage, meta: { title: "Flussi" } },
    { name: "FlussiViewPage", path: "/flussi/view/:id", component: Flussi.FlussiViewPage, meta: { title: "Flussi" } },
    { name: "Flussi Fattura Anticipata", path: "/flussifatturaanticipata", component: Flussi.FlussiFatturaAnticipataListPage, meta: { title: "Flussi Fattura Anticipata" } },
];
export default routes;
